var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p"},[_vm._m(0),_c('div',{ref:"myecharts",attrs:{"id":"myecharts"},on:{"click":function($event){return _vm.jumpDetil($event)}}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-head"},[_c('i',{staticClass:"head-icon"}),_c('p',{staticClass:"head-title"},[_vm._v("题目作答情况分布")])])
}]

export { render, staticRenderFns }